import type { Language } from '../i18n';

export function getSkillLabel(skill: string, language: Language): string {
	const key = String(skill || '').trim().toLowerCase();
	const map: Record<string, { en: string; de: string; hr: string }> = {
		hardscaping: { en: 'Hardscaping', de: 'Bauarbeiten', hr: 'Građevinski radovi' },
		planting: { en: 'Planting', de: 'Pflanzung', hr: 'Sadnja' },
		irrigation: { en: 'Irrigation', de: 'Bewässerung', hr: 'Navodnjavanje' },
		pruning: { en: 'Pruning', de: 'Rückschnitt', hr: 'Orezivanje' },
		lawn_care: { en: 'Lawn care', de: 'Rasenpflege', hr: 'Njega travnjaka' },
		design: { en: 'Design', de: 'Planung', hr: 'Dizajn' },
		maintenance: { en: 'Maintenance', de: 'Pflege', hr: 'Održavanje' },
		project_management: { en: 'Project management', de: 'Projektmanagement', hr: 'Upravljanje projektom' },
		sustainable_gardening: { en: 'Sustainable gardening', de: 'Nachhaltiges Gärtnern', hr: 'Održivo vrtlarstvo' },
		fencing_structures: { en: 'Fencing & structures', de: 'Zäune und Konstruktionen', hr: 'Ograde i konstrukcije' },
		water_features: { en: 'Water features', de: 'Wasserelemente', hr: 'Vodeni elementi' },
		lighting: { en: 'Lighting', de: 'Beleuchtung', hr: 'Rasvjeta' },
		drainage: { en: 'Drainage', de: 'Entwässerung', hr: 'Odvodnja' }
	};

	const labels = map[key];
	if (!labels) return key.replace(/_/g, ' ');
	if (language === 'de') return labels.de;
	if (language === 'hr') return labels.hr;
	return labels.en;
}

